import React, { useState } from "react";
import axios from "axios";
import { CheckCircle, ChevronDown, SmsFailed } from "../constants/icons";

function TacForm({
     fields = [],
     formid = "",
     first = "",
     second = "",
     third = "",
     buttonText = "Submit",
}) {
     const clientKey = "theafrocollective";
     const apiUrl = "https://7t0xfgk6y1.execute-api.eu-west-2.amazonaws.com/form";

     const [formData, setFormData] = useState(
          fields.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {})
     );

     const [resultMessage, setResultMessage] = useState("");
     const [showOverlay, setShowOverlay] = useState(false);

     const handleChange = (e) => {
          const { name, value } = e.target;
          setFormData((prev) => ({
               ...prev,
               [name]: value,
          }));
     };

     const handleSubmit = async (e) => {
          e.preventDefault();
          setShowOverlay(true);

          try {
               const response = await axios.post(apiUrl, {
                    client: clientKey,
                    formid,
                    ...formData,
               });

               if (response.status === 200) {
                    let secondLine = "";
                    switch (formid) {
                         case "mailing":
                              secondLine =
                                   "You will now receive emails from us in light of new events and updates.";
                              break;
                         case "reviews":
                              secondLine = "Thank you for your review.";
                              break;
                         case "artist":
                         case "contact":
                              secondLine = "Thank you for your message, we'll be in touch soon!";
                              break;
                         default:
                              secondLine = "";
                    }

                    setResultMessage(
                         <div className="result-overlay">
                              <div className="first-line">
                                   <CheckCircle className="xicon" /> <p>Submitted Successfully</p>
                              </div>
                              <div className="second-line">
                                   <p>{secondLine}</p>
                              </div>
                         </div>
                    );

                    setFormData(
                         fields.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {})
                    );
               } else {
                    throw new Error("Submission failed");
               }
          } catch (error) {
               console.error(error);
               setResultMessage(
                    <div className="result-overlay">
                         <SmsFailed className="yicon" />
                         <p>Something went wrong. Please try again.</p>
                    </div>
               );
          }

          setTimeout(() => {
               setShowOverlay(false);
               setResultMessage(null);
          }, 3000);
     };

     return (
          <div className="form-info">
               <div className="form-text">
                    {first && <h2>{first}</h2>}
                    {second && <p>{second}</p>}
                    {third && <p>{third}</p>}
               </div>

               <div className="form-container">
                    <form className="contact-form-content" onSubmit={handleSubmit}>
                         {fields.map((field) => (
                              <div key={field.name} className="form-field">
                                   <label htmlFor={field.name}>{field.label}:</label>

                                   {field.type === "textarea" ? (
                                        <textarea
                                             id={field.name}
                                             name={field.name}
                                             value={formData[field.name]}
                                             onChange={handleChange}
                                             required={field.required}
                                             autoComplete={field.autoComplete || "off"}
                                        />
                                   ) : field.type === "select" ? (
                                        <div className="custom-select">
                                             <div
                                                  className={`select-header ${formData[`${field.name}_open`] ? "square" : ""
                                                       }`}
                                                  onClick={() =>
                                                       setFormData((prev) => ({
                                                            ...prev,
                                                            [`${field.name}_open`]: !prev[`${field.name}_open`],
                                                       }))
                                                  }
                                             >
                                                  {formData[field.name] || "Select an option"}
                                                  <ChevronDown
                                                       className={`icon ${formData[`${field.name}_open`] ? "rotate" : ""
                                                            }`}
                                                  />
                                             </div>

                                             {formData[`${field.name}_open`] && (
                                                  <div className="select-dropdown fadein">
                                                       {field.options?.map((option) => (
                                                            <div
                                                                 key={option}
                                                                 onClick={() =>
                                                                      setFormData((prev) => ({
                                                                           ...prev,
                                                                           [field.name]: option,
                                                                           [`${field.name}_open`]: false,
                                                                      }))
                                                                 }
                                                            >
                                                                 {option}
                                                            </div>
                                                       ))}
                                                  </div>
                                             )}

                                             <input type="hidden" name={field.name} value={formData[field.name]} />
                                        </div>
                                   ) : (
                                        <input
                                             type={field.type}
                                             id={field.name}
                                             name={field.name}
                                             value={formData[field.name]}
                                             onChange={handleChange}
                                             required={field.required}
                                             autoComplete={field.autoComplete || "off"}
                                        />
                                   )}
                              </div>
                         ))}

                         <button type="submit">{buttonText}</button>
                    </form>
               </div>

               {showOverlay && (
                    <div className="result-overlay" onClick={() => setShowOverlay(false)}>
                         {resultMessage}
                    </div>
               )}
          </div>
     );
}

export default TacForm;
